import React from 'react'
import { AppRetailerBlock } from "@components"


export default function siteColumn() {

	return {
		name: 'name',
		label: 'Site',
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRender: (siteName, { market, icon }) => <AppRetailerBlock retailer={siteName} country={market} icon={icon}/>,
		}
	}
}